import { useQuery } from 'react-query'
import { useEffect } from 'preact/hooks'
import { Helmet, LoadingEllipsis } from '@/core'
import { BarGraph } from '@c/bar-graph'
import { GraphCard } from '@c/graph-card'
import { API_URL } from '@/consts'
import { useAdminMetrics } from '@u/drf/hooks'
import { doc } from './doc'
import moment from 'moment-timezone'
import styles from './style.module.less'

const calcMaxY = (data) => Math.max(...data) + 2

const calcMonthValues = (data) =>
  data
    .map((v, i) => [
      moment().subtract(i, 'months').format('MMM'),
      v,
    ])
    .reverse()

export const AdminMetrics = doc(() => {
  const [metrics, query] = useAdminMetrics()

  return (
    <div className={styles.base}>
      <Helmet title="Metrics" />
      <h1>Metrics</h1>
      {!metrics && <LoadingEllipsis padded />}
      {metrics && (
        <div className={styles.cards}>
          <GraphCard title="Company Sign Ups">
            <BarGraph
              color="green"
              maxY={calcMaxY(metrics.companySignups.months)}
              values={calcMonthValues(metrics.companySignups.months)}
            />
          </GraphCard>
          <GraphCard title="Employee Sign Ups">
            <BarGraph
              maxY={calcMaxY(metrics.employeeSignups.months)}
              values={calcMonthValues(metrics.employeeSignups.months)}
            />
          </GraphCard>
          <GraphCard title="RSVP Events Created">
            <BarGraph
              color="lightGreen"
              maxY={calcMaxY(metrics.rsvpEventsCreated.months)}
              values={calcMonthValues(metrics.rsvpEventsCreated.months)}
            />
          </GraphCard>
          <GraphCard title="Opportunity Requests Received">
            <BarGraph
              color="lightBlue"
              maxY={calcMaxY(metrics.opportunityRequestsReceived.months)}
              values={calcMonthValues(
                metrics.opportunityRequestsReceived.months
              )}
            />
          </GraphCard>
          <GraphCard title="Total Volunteers">
            <BarGraph
              color="purple"
              maxY={calcMaxY(metrics.reservations.months)}
              values={calcMonthValues(
                metrics.reservations.months
              )}
            />
          </GraphCard>
          <GraphCard title="RSVP Event Feedback Avg Response Rate">
            <div className={styles.singleStatCard}>
              <h2 className={styles.stat}>
                <strong>{metrics.rsvpFeedbackAverageResponseRate}%</strong>
              </h2>
              <p className={styles.statDescription}>
                *Based on RSVP events from the start of 2024
              </p>
            </div>
          </GraphCard>
          <GraphCard title="Employees with an assigned department">
            <div className={styles.singleStatCard}>
              <h2 className={styles.stat}>
                <strong>{metrics.departmentSelectedPercentage}%</strong>
              </h2>
              <p className={styles.statDescription}>
                Percentage of company employees who have assigned themselves a
                department
              </p>
            </div>
          </GraphCard>
        </div>
      )}
    </div>
  )
})
